import { Box } from '@mui/material';
import React from 'react';
import GetSocialMediaIcon from 'src/components/GetSocialMediaIcon';

const WAButton = React.forwardRef<HTMLDivElement>((props, ref) => {
  const contactLink =
    'https://api.whatsapp.com/send/?phone=628112207900&text=Halo%20NoLimit%2C%20saya%20ingin%20bertanya%20tentang%20produk%20NoLimit.%20Terima%20kasih.';
  return (
    <Box
      {...props}
      ref={ref}
      sx={{
        backgroundColor: '#26872E',
        position: 'fixed',
        zIndex: 999,
        width: '42px',
        height: '42px',
        bottom: '110px',
        right: '20px',
        borderRadius: '100%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={() => window.open(contactLink, '_blank')}
      component="div"
    >
      <GetSocialMediaIcon
        socialMedia={'whatsapp'}
        sx={{ fontSize: 30, color: '#FBFBFB' }}
      />
    </Box>
  );
});

WAButton.displayName = 'WAButton';

export default WAButton;
